import { render, staticRenderFns } from "./ApiCallsExceeded.vue?vue&type=template&id=bfa2fb06"
import script from "./ApiCallsExceeded.vue?vue&type=script&lang=js"
export * from "./ApiCallsExceeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports